import { render, staticRenderFns } from "./mnExam.vue?vue&type=template&id=51becb06&scoped=true"
import script from "./mnExam.vue?vue&type=script&lang=js"
export * from "./mnExam.vue?vue&type=script&lang=js"
import style0 from "./mnExam.vue?vue&type=style&index=0&id=51becb06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51becb06",
  null
  
)

export default component.exports